// Vista de enviar invitaciones 


//Imports 
import React, {createRef}  from 'react';
import plantillaMails from './files/plantilla_mails.txt';
import moment from 'moment';
import {
    Form,
    Col,
    Row,
    Input,
    Button,
    Upload,
    Breadcrumb,
    DatePicker,
    Select,
    Card,
    Divider,
    Modal,
    notification,
    Space,
    Radio,
    Spin
} from "antd";
import {UploadOutlined, MinusCircleOutlined, PlusOutlined, ExclamationCircleOutlined, SearchOutlined, DownloadOutlined} from '@ant-design/icons';
import {Invites,
    getTypesVisits,
    getOrganismos,
    getSponsorsParams,
    getOrganismosRepart,
    crearSolUni,
    emailVerifierUrl} from "./VisitConsumer";
import {CheckCircleTwoTone, CloseCircleTwoTone} from '@ant-design/icons';

import axios from 'axios';

const {RangePicker} = DatePicker;
const {Option} = Select;
const {confirm} = Modal;

const form = createRef();
const formSponsor = createRef();
const API_URL = window.ENV.API_URL+'';
//formulario-visita/2166/
//window.ENV.API_URL+"/formulario-visita/2166/"

//Componente de Enviar invitaciones
class SendInvitations extends React.Component {
    //Estados del componente 
    state = {
        funcionarios: [],
        emails_exitosos: [],
        emails_rechazados: [],
        value: null,
        loadings: [],
        carga_masiva: [],
        visible: false,
        index:  0,
        tiposvisita: [],
        organismos: [],
        organismos_data: [],
        departamentos: [],
        reparticiones: [],
        emailsCSV: [],
        fileName: "",
        checkValue: '0',
        sponsorBuscado: "",
        loadingSponsorButton: 0,
        ingresarNombres: '',
        dataUser: "",
        visitaSinCargar: true,
        nivelTresSeleccionado: false,
        nombreFacultadSeleccionada: '',
        modalNotOk: false,
        sendButton: false
    }

    //Función para bloquear el boton de enviar mientras se ejecuta la función Invites 
    enterLoading = index => {
        this.setState(({loadings}) => {
            const newLoadings = [...loadings];
            newLoadings[index] = true;
            return {
                loadings: newLoadings,
            };
        });
    };

    //Al cargar el componente  tomamos los valores de la API para poner rellenar 
    componentDidMount() {
        localStorage.setItem('mails', JSON.stringify({'mails_enviados': [], 'mails_rechazados': []}));
        /* getSponsors().then((response) => {
            this.setState({funcionarios: response.data});
        }); */
        getTypesVisits().then((response) => {
            this.setState({tiposvisita: response.data})
        });
        getOrganismos().then((response1) => {
            let reparticion_data = response1.data.filter( (organismo) => parseInt(organismo.nivel) === 2);
            this.setState({
                organismos_data: response1.data,
                reparticiones: reparticion_data
            });
            getOrganismosRepart(window.Roles[0].code).then((response2) => {
                console.log(response2.data[0])
                if(window.Roles[0].Permisos[0] === "page_registrar_visita"){
                    let reparticionUser = reparticion_data.filter((organismo) => parseInt(response2.data[0].id_organismo_padre) === organismo.id_organismo)
                    let organismoUser = response1.data.filter((organismo) => parseInt(response2.data[0].id_organismo) === organismo.id_organismo)
                    this.setState({
                        organismos: organismoUser,
                        reparticiones: reparticionUser
                    })
                    this.handleonChange_reparticion(response2.data[0].id_organismo_padre)
                    this.handleonChange_organismo(response2.data[0].id_organismo)
                    form.current.setFieldsValue({
                        reparticion: response2.data[0].id_organismo_padre,
                        organismo: response2.data[0].id_organismo
        
                    })
                }
                this.setState({dataUser: response2.data[0], visitaSinCargar: false})
            });
        });
    };

    // Aca se procesa la data para la carga masiva
    // Se debe hacer check del tipo csv
    handleFile = (file) => {
        const mail_sponsors = [];
        const reader = new FileReader();
        reader.onload = evt => {
            const content = evt.target.result.split("\n");
            const contact = [];
            for(var i=0; i < content.length; i++){
                const line = content[i].replace(' ','');
                if (line == ''){
                    continue;
                } else {
                contact.push(line);
                }
            }
            //console.log(evt.target.result);
            this.setState({emailsCSV: contact, fileName: file.name});
            /* console.log(contact);
            console.log(this.state.emailsCSV);
            console.log(this.state.fileName) */
            
        };
        reader.readAsText(file);
    };

    //Mostrar el modal de carga masiva
    showModal = (indice) => {
        this.setState({
            index: indice,
            visible: true,
        });
    };

    // Cerrar el modal 
    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    //Eliminar un archivo seleccionado para ser cargado
    deleteFile = index => {
        const contacts = this.state.carga_masiva;
        contacts.splice(index, 1);
        this.setState({carga_masiva: contacts});
    };

    //Filtrar por  unidad una vez seleccionada la facultad 
    handleonChange_organismo = (value,event) => {
        var organismos =  this.state.organismos_data
        var nombreFacultad = organismos.filter((organismo)  => parseInt(organismo.id_organismo) === parseInt(value))
        if(form.current.getFieldValue("sponsor")){
            form.current.setFieldsValue({sponsor: null })
        }
        if(window.Roles[0].Permisos[0] === "registrar_visita_superadmin"){
            if(form.current.getFieldValue("departamento")){
                form.current.setFieldsValue({departamento: null })
            }
        }
        this.setState({
            departamentos:  organismos.filter((organismo)  => parseInt(organismo.id_organismo_padre) === parseInt(value)),
            nivelTresSeleccionado: true,
            nombreFacultadSeleccionada: nombreFacultad[0].nombre,
            funcionarios: []
        });
    }
    
    handleonChange_reparticion = (value,event) => {
        let organismos;
        if(form.current.getFieldValue("sponsor")){
            form.current.setFieldsValue({sponsor: null })
        }
        if(window.Roles[0].Permisos[0] === "registrar_visita_superadmin"){
            if(form.current.getFieldValue("organismo")){
                form.current.setFieldsValue({organismo: null })
            }
            if(form.current.getFieldValue("departamento")){
                form.current.setFieldsValue({departamento: null })
            }
            this.setState({nivelTresSeleccionado: false})
        }
        if(window.Roles[0].Permisos[0] === "page_registrar_visita"){
            organismos =  this.state.organismos
        } else {
            organismos =  this.state.organismos_data
        }
        this.setState({
            organismos:  organismos.filter((organismo)  => parseInt(organismo.id_organismo_padre) === parseInt(value)),
            funcionarios: []
        });
    }

    render() {
        //Data para Mostrar en el modal una vez procesado la plantilla 
        const columns = [
          {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
          },
          {
            title: 'Nombres',
            dataIndex: 'nombres',
            key: 'nombres',
          },
            {
            title: 'Apellidos',
            dataIndex: 'apellidos',
            key: 'apellidos',
          },
            {
            title: 'Correo',
            dataIndex: 'correo',
            key: 'correo',
          },
            {
            title: 'Fecha de inicio',
            dataIndex: 'inicio',
            key: 'inicio',
          },
            {
            title: 'Fecha de termino',
            dataIndex: 'termino',
            key: 'termino',
          },
            {
            title: 'Patrocinador',
            dataIndex: 'sponsor',
            key: 'sponsor',
            render: funcionario => (
                  <>
                    {funcionario.id_patrocinador}
                  </>
            ),

          },
          {
            title: 'Facultad',
            dataIndex: 'facultad',
            key: 'facultad',
            render: facu => (
                <>
                  {facu ? facu.facultad : " "}
                </>
          ),
        
          },
          {
            title: 'Unidad ',
            dataIndex: 'unidad',
            key: 'unidad',
            render: uni => (
                <>
                  {uni ? uni.unidad : " "}
                </>
          ),
        
          },
          {
            title: 'Tipo de Visita ',
            dataIndex: 'visittype',
            key: 'visittype',
            render: visita => (
                <>
                  {visita ? visita.tipos_visita : " "}
                </>
          ),
        
          },
          
          
            {
            title: 'Verificacion',
            dataIndex: 'verificacion',
            key: 'verificacion',
            render: verificacion => (
                  <>
                    {verificacion ? <CheckCircleTwoTone twoToneColor="#52c41a"/> : <CloseCircleTwoTone twoToneColor="#FF2424"/>}
                  </>
            ),
          },
        ];

        // Para la carga individual
        const onChangeCheckbox = e => {
            let valor = e.target.value
            formSponsor.current.resetFields();
            formSponsor.current.setFieldsValue({
                checkRut: valor
            })
            this.setState({checkValue: valor})
        };

        const searchSponsor = values => {
            if(values.checkRut === '0'){
                var dataF = values.rut_pasaporte.replace("-","")
                for(let ix=0;ix<10-values.rut_pasaporte.replace("-","").length;ix++){
                    dataF = "0" + dataF
                }
                values.rut_pasaporte = dataF.toUpperCase()
            } else {
                if((!values.nombres && !values.paterno && !values.materno)){
                    this.setState({ingresarNombres: "Debe ingresar por lo menos un campo"});
                    /* notification.open({
                        message: "Error",
                        description: "Debe ingresar por lo menos un campo",
                        type: "error",
                        duration: 0,
                    }); */
                    return
                } else {
                    this.setState({ingresarNombres: ""});
                } 
            }
            values.nivelTres = form.current.getFieldValue("organismo");
            values.dataUser = window.Roles[0].code
            this.setState({loadingSponsorButton: 1});
            getSponsorsParams(values).then(res => {
                /* console.log(res.data) */
                this.setState({funcionarios: [res.data],loadingSponsorButton: 0})
            }).catch(function (error) {
                console.log(error)
            })
        };

        const setSponsor = values => {
            form.current.setFieldsValue({
                sponsor: parseInt(values)
            })
            this.handleCancel()
        }

        const renderSponsors = () => {
            if(this.state.funcionarios.length > 0){
                if(this.state.funcionarios[0][0].nombres == "notfound"){
                    return(<div>{"No se encontraron resultados."}</div>)
                } else {
                    return(<div> Resultados: <br/>{this.state.funcionarios[0].map(sponsor => (
                    <div> <Button type="link" onClick={() => {setSponsor(sponsor.id_persona)}}> {sponsor.nombres} {sponsor.paterno} {sponsor.materno} </Button> </div>
                ))} </div> )
                }
            } else {
                return (null)
            }
        }

        const downloadFile = () => {
            const link = document.createElement('a');
            link.href = plantillaMails;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }

        const datosCampos= () =>{
            console.log("fields:",form.current.getFieldValue())
        }

        const initial = { checkRut: "0"};

        const showModalNotOk = () => {
            this.setState({
                modalNotOk: true,
            });
        };

        const hideModalNotOk = () => {
            this.setState({
                modalNotOk: false,
                submitButtonload: false,
            });
        };

        const loadingButton = () => {
            this.setState({
                sendButton: true,
            });
        };

        const regularButton = () => {
            this.setState({
                sendButton: false,
            });
        };

        const onFinish = values => {
            let emailsArchivo = this.state.emailsCSV;
            const re_mail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let namesEmails = [];
            if (values.names && emailsArchivo.length > 0){
                namesEmails = values.names;
                for(let ix=0;ix<emailsArchivo.length;ix++){
                    let mailNoExiste = 1;
                    for(let px=0;px<values.names.length;px++){
                        if(emailsArchivo[ix] == values.names[px]){
                            mailNoExiste = 0;
                            break;
                        }
                    }
                    if (mailNoExiste){
                        namesEmails.push(emailsArchivo[ix]);
                    }
                }
            }
            if (values.names && emailsArchivo.length == 0){
                namesEmails = values.names;
            }
            if (!values.names && emailsArchivo.length > 0){
                namesEmails = emailsArchivo;
            }
            for(let ix=0;ix<namesEmails.length;ix++){
                if(!re_mail.test(String(namesEmails[ix]).toLowerCase())){
                    namesEmails.splice(ix,1)
                    ix--
                }
            }
            let aux = []
            for(let ix=0;ix<namesEmails.length;ix++){
                if(!aux.includes(namesEmails[ix].toLowerCase())){
                    aux.push(namesEmails[ix].toLowerCase())
                }
            }
            values.names = aux;
            if(values.names.length === 0){
                notification.open({
                    message: "No ingresó ningún mail",
                    description: "Debe ingresar por lo menos 1 mail.",
                    type: "error",
                    duration: 5,
                });
                return
            };
            const params = {
                "correos": values.names,
                "tipo_visita": values.visittype,
                "id_sponsor": values.sponsor,
                "inicio_visita": values.vigencia[0].format('YYYY-MM-DD'),
                "termino_visita": values.vigencia[1].format('YYYY-MM-DD'),
                "departamento": values.departamento,
                "organismo": values.organismo,
                "depart": this.state.departamentos
            }
            localStorage.setItem('sent_info',JSON.stringify({
                'sponsor' : values.sponsor,
                "inicio_visita": values.vigencia[0].format('YYYY-MM-DD'),
                "termino_visita": values.vigencia[1].format('YYYY-MM-DD')
            }))
            confirm({
                okText: 'Aceptar',
                cancelText: 'Cancelar',
                content: <div><div style={{textAlign:"center", marginBottom: "40px"}}><ExclamationCircleOutlined style={{fontSize: "60px", color: "#FFBA5C"}}/></div><div style={{fontSize: "19px", color:"#8190A5", marginBottom: "20px", textAlign:"center"}}>¿Está seguro de enviar estas invitaciones?</div></div>,
                cancelButtonProps: {className: 'global-secundario-button'},
                okButtonProps: {className: 'global-principal-button'},
                width:"600px",
                 onOk() {
                    loadingButton()
                    Invites(params).then((response) => {
                        console.log(response);
                        localStorage.setItem('mails', JSON.stringify({'mails_enviados': response.data[0].email_buenos, 'mails_rechazados': response.data[0].email_malos}));
                        window.location.href = "/sentinvites"
                    }).catch((error) => {
                        console.log(error);
                        regularButton()
                        showModalNotOk()
                    })
                },
                onCancel(){
                    regularButton()
                },
            });
        };

        // para boton loading
        const {loadings} = this.state;

        return (
            <Spin tip="Cargando Datos…" spinning={this.state.visitaSinCargar}>
            <Form ref={form} layout={'vertical'} name="emails" onFinish={onFinish}>
                <div>
                    <div>
                        <Modal visible={this.state.modalNotOk} width={600} style={{textAlign: 'center', color: '#47525E'}} closeIcon=' ' footer={null}>
                                <CloseCircleTwoTone style={{fontSize: "49px"}}twoToneColor="#FF4D4F"/>
                                <div style={{color:"#47525E", fontSize: "20px", marginTop: "10px"}}>Ocurrió un error al enviar las invitaciones, intentelo nuevamente.</div>
                            <Divider style={{background: '#969FAA'}}/>
                            {/* <Button className='global-secundario-button'><Link to='/main'>MAIN</Link></Button> */}
                            <div style={{textAlign: 'right'}}>
                                <Button className='global-principal-button' onClick={() => {hideModalNotOk()}} >ACEPTAR</Button>
                            </div>
                        </Modal>
                    </div>

                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <a href="/main">Menú principal</a>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>Enviar invitaciones</Breadcrumb.Item>
                    </Breadcrumb>
                    <Card>
                        <h1 style={{color: '#116EC0'}}><b>Enviar Invitaciones</b></h1>
                        <div style={{fontWeight: 'bold', marginBottom: '10px'}}>Agrega contactos para que puedan recibir el formulario de forma remota por mail.</div>
                        <Row>
                            <Col span={11}>
                                <Form.Item label={<label className='formvisit-label'>Repartición</label>}
                                           rules={[{required: true, message: "La repartición es requerida"}]}
                                           name="reparticion">
                                    <Select
                                        className='sendinvitations-select'
                                        placeholder="Reparticion"
                                        style={{width: '80%'}}
                                        allowClear
                                        onSelect={(value,event)=> this.handleonChange_reparticion(value,event)}
                                    >
                                        {this.state.reparticiones.map(filteredReparticion => (
                                            <Option
                                                value={filteredReparticion.id_organismo}>{filteredReparticion.nombre}</Option>

                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item label={<label className='formvisit-label'>Organismo</label>}
                                           rules={[{required: true, message: "El organismo es requerida"}]}
                                           name="organismo">
                                    <Select
                                        className='sendinvitations-select'
                                        placeholder="Organismo"
                                        style={{width: '80%'}}
                                        allowClear
                                        onSelect={(value,event)=> this.handleonChange_organismo(value,event)}
                                    >
                                        {this.state.organismos.map(filteredOrganismo => (
                                            <Option
                                                value={filteredOrganismo.id_organismo}>{filteredOrganismo.nombre}</Option>

                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item label={<label className='formvisit-label'>Unidad / Departamento</label>}
                                           rules={[{required: true, message: "El departamento es requerido"}]}
                                           name="departamento">
                                    <Select
                                        className='sendinvitations-select'
                                        placeholder="Departamento"
                                        style={{width: '80%'}}
                                        allowCleare
                                    >
                                        {this.state.departamentos.map(filteredDepartamento => (
                                            <Option
                                                value={filteredDepartamento.id_organismo}>{filteredDepartamento.nombre}</Option>

                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={2}>
                                <Divider type="vertical" style={{ height: "100%", borderColor: "#D2D7E0" }} />
                            </Col>
                            <Col span={11}>
                                <Row>
                                    <Col span={12}>
                                    <Form.Item label={<label className='formvisit-label'>Patrocinador</label>}
                                            rules={[{required: true, message: "El patrocinador es requerido"}]}
                                            name="sponsor">
                                        <Select
                                            placeholder="Patrocinador"
                                            className='sendinvitations-select'
                                            allowClear
                                            disabled
                                        >
                                            {this.state.funcionarios.length >= 1 ? this.state.funcionarios[0].map(sponsor => (
                                                <Option
                                                    value={parseInt(sponsor.id_persona)}>{sponsor.nombres} {sponsor.paterno} {sponsor.materno}</Option>

                                            )) : this.state.funcionarios.map(sponsor => (
                                                <Option
                                                    value={parseInt(sponsor.id_persona)}>{sponsor.nombres} {sponsor.paterno} {sponsor.materno}</Option>

                                            ))}
                                        </Select>
                                    </Form.Item>
                                    </Col>
                                    <Col span={12}>
                                    { this.state.nivelTresSeleccionado ? <Button className='global-secundario-button' style={{marginTop: 30, marginLeft: 20}} onClick={() => {this.showModal()}} /* icon={<EyeOutlined />} */>
                                        <SearchOutlined /> BUSCAR PATROCINADOR
                                    </Button> :
                                    <Button className='global-disable-button' style={{marginTop: 30, marginLeft: 20}} disabled onClick={() => {this.showModal()}} /* icon={<EyeOutlined />} */>
                                        <SearchOutlined /> BUSCAR PATROCINADOR
                                    </Button> }
                                    </Col>
                                </Row>
                                <Form.Item label={<label className='formvisit-label'>Tipo de visita</label>}
                                           rules={[{required: true, message: "El tipo de visita es requerido"}]}
                                           name="visittype">
                                    <Select
                                        className='sendinvitations-select'
                                        placeholder="Tipo de Visita"
                                        style={{width: '80%'}}
                                        allowClear
                                    >
                                        {this.state.tiposvisita.map(filteredVisita => (
                                            <Option
                                                value={parseInt(filteredVisita.id)}>{filteredVisita.tipo_visita}</Option>

                                        ))}
                                    </Select>
                                </Form.Item>
                                <Form.Item label={<label className='formvisit-label'>Vigencia</label>}
                                           rules={[{required: true, message: "La vigencia es requerida"},
                                           { validator: async (rule, value) => {
                                                if (!value){
                                                    return
                                                }
                                                let hoy = new Date().toISOString().split('T')[0]
                                                let anioInicial = parseInt(value[0].format('YYYY-MM-DD').split('-')[0]) 
                                                let anioSiguiente = (anioInicial + 1) + '-' + value[0].format('YYYY-MM-DD').split('-')[1] + '-' + value[0].format('YYYY-MM-DD').split('-')[2]
                                                if(value[0].format('YYYY-MM-DD') < hoy){
                                                        throw new Error('La fecha inicial no puede ser pasada');
                                                }
                                                if(anioSiguiente < value[1].format('YYYY-MM-DD')){
                                                    throw new Error('La vigencia no puede superar 1 año')
                                                }
                                             }
                                            }
                                        ]}
                                           name="vigencia">
                                    <RangePicker style={{borderColor:"#A3AEBB"}} placeholder={["Inicio", "Término"]}/>
                                </Form.Item>
                            </Col>
                        </Row>

                                <Modal
                                    title={<div style={{color: "#4B5660", fontSize: "20px", fontWeight: "bold"}}> <div><SearchOutlined style={{marginRight:"10px"}}/> Buscar patrocinador</div></div>}
                                    visible={this.state.visible}
                                    onOk={null}
                                    onCancel={this.handleCancel}
                                    width={"633px"}
                                    footer={null}
                                >
                                    <div style={{color:"#5A6978", fontSize: "13px", marginLeft:"56px"}}><b>Ud. está buscando en: </b></div>
                                    <div style={{lineHeight:"19px", color:"#0A5DA6", fontSize: "16px", marginLeft:"56px"}}><b>{this.state.nombreFacultadSeleccionada}</b></div>
                                    <div style={{color:"#5A6978", fontSize: "15px", marginLeft:"56px", marginBottom:"20px"}}>Puede buscar por rut o nombre, apellidos.</div>
                                    <Form ref={formSponsor} layout={'vertical'} name="sponsorsForm"  onFinish={searchSponsor} initialValues={initial} >
                                    <Form.Item name="checkRut">
                                    <Radio.Group onChange={onChangeCheckbox}>
                                        <Space size="middle">   
                                        <Radio value="0"> </Radio>
                                            <Form.Item
                                                name='rut_pasaporte'
                                                label={<label className='formvisit-label'>Rut</label>}
                                                rules={[{
                                                    message: 'Formato RUT es 12345678-9',
                                                    pattern: "$|^[0-9][0-9][0-9][0-9][0-9][0-9][0-9][0-9]?-(k|K|[0-9])$"},
                                                    {
                                                    validator: async (rule, value) => {
                                                        if (!value){
                                                            return
                                                        }
                                                        if (value.split("-").length < 2 || value.split("-")[1].length != 1) {
                                                            throw new Error('RUT incorrecto.');
                                                            return;
                                                        }
                                                        let rut = value.split("-")[0];
                                                        let verificador = '' + value.split("-")[1];
                                                        let verCalc = '';
                                                        let sum = 0;
                                                        let mul = 2;
                                                    
                                                        let i = rut.length;
                                                        while (i--) {
                                                        sum = sum + parseInt(rut.charAt(i)) * mul;
                                                        if (mul % 7 === 0) { mul = 2; }
                                                        else { mul++; }
                                                        }
                                                    
                                                        const res = '' + sum % 11;

                                                        if (res === '0'){
                                                            verCalc = '0';
                                                        } else {
                                                            if (res === '1'){
                                                                verCalc = 'k';
                                                            } else {
                                                                verCalc = '' + (11-res)
                                                            }
                                                        }
                                                        if (verificador.toUpperCase() === verCalc.toUpperCase()){
                                                            console.log("DV correcto")
                                                            return;
                                                        } else {
                                                            console.log("DV incorrecto")
                                                            throw new Error('RUT incorrecto.');
                                                        }
                                                    }
                                                } ]}
                                            >   
                                            {this.state.checkValue==='0' ? <Input className='formvisit' placeholder="12345678-9"/> : <Input className='formvisit' placeholder="12345678-9" disabled/>}
                                            </Form.Item>
                                            </Space>
                                            <div>
                                            <Space size="middle">
                                            <Radio name="checkNombre" value="1"> </Radio>
                                                <Form.Item name='nombres' label={<label className='formvisit-label'>Nombre y/o apellidos</label>}
                                                    rules={[{
                                                        pattern: "^([^0-9]*)$",
                                                        message: "El nombre no puede tener números"
                                                    }]}>{this.state.checkValue==='1' ? <Input className='formvisit' placeholder="Juan Pérez"/> : <Input className='formvisit' placeholder="Juan Pérez" disabled/>}
                                                </Form.Item>
                                            </Space>
                                            {this.state.ingresarNombres === '' ? null : <p style={{marginLeft:"50px", color:"red"}}>{this.state.ingresarNombres}</p>}
                                            </div>
                                    </Radio.Group>
                                    </Form.Item>
                                    <Divider/>
                                    <div style={{textAlign: 'right'}}>
                                        <Space size="middle" >
                                            <Button
                                                className="global-secundario-button"
                                                onClick={() => {this.handleCancel()}}
                                            >
                                                Cancelar
                                            </Button>
                                            <Button
                                                className="global-principal-button"
                                                htmlType="submit"
                                                loading={this.state.loadingSponsorButton}
                                            >
                                                Buscar
                                            </Button>
                                        </Space>
                                    </div>
                                    </Form>
                                    {renderSponsors()}
                                </Modal>

                                {/*Carga individual*/}
                                <Form.List name="names">
                                    {(fields, {add, remove}) => {
                                        return (
                                            <div>
                                                {fields.map((field, index) => (
                                                    <Form.Item
                                                        required={false}
                                                        key={field.key}
                                                    >
                                                        <Form.Item
                                                            {...field}
                                                            validateTrigger={['onChange', 'onBlur']}
                                                            rules={[
                                                                {
                                                                    required: true,
                                                                    whitespace: true,
                                                                    type: 'email',
                                                                    message: "Por favor, ingresa un email o borra este campo.",
                                                                },
                                                            ]}
                                                            noStyle
                                                        >
                                                            <Input placeholder="Ingresa el email aquí"
                                                                   className="email"/>
                                                        </Form.Item>
                                                        {fields.length >= 1 ? (
                                                            <MinusCircleOutlined
                                                                className="dynamic-delete-button"
                                                                onClick={() => {
                                                                    remove(field.name);
                                                                }}
                                                            />
                                                        ) : null}
                                                    </Form.Item>
                                                ))}
                                                <Form.Item>
                                                    <Button
                                                        className='global-secundario-button'
                                                        onClick={() => {
                                                            add();
                                                        }}>
                                                        <PlusOutlined/> AGREGAR DESTINATARIO
                                                    </Button>
                                                </Form.Item>
                                                {this.state.fileName ? <h3 style={{color: "black", marginLeft: '2%'}}>Cargado actualmente: {this.state.fileName}</h3> : null}
                                                <Divider plain/>
                                                <Space direction="vertical">
                                                    <label className='formvisit-label' style={{fontWeight: 'bold'}}>Si lo prefiere, puede subir varios de los mails de manera simultánea vía la siguiente plantilla.</label>
                                                    <label className='formvisit-label'>Descargar plantilla tipo</label>
                                                </Space>
                                                <Form.Item>
                                                    <Space direction="vertical">
                                                        <a href={plantillaMails} download="plantilla_mails">
                                                            <Button
                                                                className='global-secundario-button'>
                                                                <DownloadOutlined /> DESCARGAR PLANTILLA
                                                            </Button>
                                                        </a>
                                                        <label className='formvisit-label'>Importar archivo</label>
                                                        <Upload
                                                            accept=".csv, .txt"
                                                            fileList={null}
                                                            beforeUpload={(file) => {
                                                                this.handleFile(file);

                                                                return false
                                                            }}
                                                        >
                                                            <Button className='global-secundario-button'>
                                                                <UploadOutlined/> SELECCIONE ARCHIVO
                                                            </Button>
                                                        </Upload>
                                                        <Divider/>
                                                        <Button
                                                            className='global-principal-button'
                                                            htmlType="submit"
                                                            loading={this.state.sendButton}
                                                            block
                                                        >
                                                            ENVIAR INVITACIONES
                                                        </Button>
                                                        {/* <Button 
                                                            type="primary" 
                                                            htmlType="button"
                                                            onClick={datosCampos}
                                                        >
                                                            Borrar campos
                                                        </Button> */}
                                                    </Space>
                                                </Form.Item>
                                            </div>
                                        );
                                    }}
                                </Form.List>
                    </Card>
                </div>
            </Form>
            </Spin>

        );
    }
}

export default SendInvitations;